module.exports = "/assets/data/26f6b56398f157bccfe1ad6a0705dc99-WC2B.data.json";